import*as e from"react";import{components as r}from"react-select";import t from"../../icons/ClearIcon/index.js";function o(o){return e.createElement(r.MultiValueRemove,o,e.createElement(t,{size:18}))}export{o as MultiValueRemove};
//# sourceMappingURL=MultiValueRemove.js.map
